import { useDispatch, useSelector } from "react-redux";
import React, { FC, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import SignUp from "../../ScreenAuth/SignUp/SignUp";
import Helmet1 from "../../modules/Loading/Helmet1";

function Route() {
  return (
    <>
      <SignUp />
      <Helmet1 />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <title>SC WORLD EXCHANGE</title>
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.8.1/css/all.css"
          integrity="sha384-50oBUHEmvpQ+1lW4y57PTFmhCaXp0ML5d60M1M7uH2+nqUivzIebhndOJK28anvf"
          crossorigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css"
        />
        <link  id="SignUp" rel="stylesheet" href="/dist/css/exis.css" onload="$('.Helmet1').hide()"/>
      </Helmet>
      {/* {width > 992 ? ( */} {/* ) : ( */}
      {/* <div id="style-sm" className="overflow-hidden"> */} {/* <Router /> */}
      {/* </div> */} {/* )} */}
      {/* <div className="d-none d-lg-block">
                    <About />
                  </div>
                  <div className="d-lg-none overflow-hidden"><AboutSm /></div> */}
    </>
  );
}

export default Route;
